interface WidgetLoadedPanoramaTransactionParams {
  start: () => void;
  finish: () => void;
  isSSR: boolean;
}

export interface WidgetLoadedPanoramaTransaction {
  start: () => void;
  markInitialized: () => void;
  markRendered: () => void;
}

export const createWidgetLoadedPanoramaTransaction = ({
  start,
  finish,
  isSSR,
}: WidgetLoadedPanoramaTransactionParams): WidgetLoadedPanoramaTransaction => {
  let isStarted = false;
  let isInitialized = false;
  let isRendered = false;
  let isFinished = false;

  const finishOnce = () => {
    if (isFinished) {
      return;
    }

    isFinished = true;
    finish();
  };

  const finishWhenLoaded = () => {
    if (isStarted && isInitialized && (isSSR || isRendered)) {
      finishOnce();
    }
  };

  return {
    start: () => {
      if (isStarted) {
        return;
      }

      isStarted = true;
      start();
      finishWhenLoaded();
    },
    markInitialized: () => {
      isInitialized = true;
      finishWhenLoaded();
    },
    markRendered: () => {
      isRendered = true;
      finishWhenLoaded();
    },
  };
};
